module.exports = __webpack_public_path__ + "static/images/monet/menu_item_selected.png";